import ConfirmationModal from "../common/components/ConfirmationModal";

interface Props {
  label: string;
  okLabel: string;
  cancelLabel: string;
  onOk?: () => void;
  onCancel: () => void;
}

export function create(data: Props) {
  return <ConfirmationModal {...data} />;
}
